// extracted by mini-css-extract-plugin
export default {"table":"CsvItemsTable_table__4qJCs","pagination":"CsvItemsTable_pagination__4tqrL"};